import { Cls_Common } from ".";

export class Cls_NotificationTopic extends Cls_Common {
  TID!: number;
  TopicName!: string;
  AID!: number;
}

export class Cls_Notification extends Cls_Common {
  NID!: number;
  NotificationTitle!: string;
  NotificationComment!: string;
  NotificationUrl!: string;
  NotificationTopicId!: number;
  NotificationReceipts?: Cls_NotificationLog[];
}

export class Cls_NotificationLog extends Cls_Common {
  NHID!: number;
  NID!: number;
  SentFrom!: number;
  SentTo!: number;
  sent_at!: number;
  seen_at!: number;
  read_at!: number;
}
